export default __webpack_public_path__ + "static/media/lumbar.6dfc3b98.webp";